export default "__VITE_ASSET__3dfa23b7__"